"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AuthTokenHandlerBase = void 0;
const AlmeAuthorizationApiBase_1 = require("./AlmeAuthorizationApiBase");
class AuthTokenHandlerBase {
    constructor(logger, httpHandler, settings) {
        this.AuthorizationApi = new AlmeAuthorizationApiBase_1.AlmeAuthorizationApiBase(logger, httpHandler, settings);
        this.AuthSettings = settings;
        this.AuthToken = null;
    }
    SetClientSecret(storage, clientSecret) {
        return __awaiter(this, void 0, void 0, function* () {
            this.ClientSecret = clientSecret;
            //get new token from Alme or load saved token.
            yield this.checkTokenExpiration(storage);
        });
    }
    getToken(storage) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.ClientSecret) {
                return null;
            }
            //call auth api to get token
            const authRequest = { ClientSecret: this.ClientSecret };
            const response = yield this.AuthorizationApi.PostAuthorizationAsync(authRequest);
            if (response) {
                const token = {
                    token: response,
                    expiresAt: this.getExpirationDateTime(response.ExpiresIn),
                };
                //save token to storage
                this.AuthToken = token;
                return storage.UpdateStorage(token) || null;
            }
            return null;
        });
    }
    checkTokenExpiration(storage) {
        return __awaiter(this, void 0, void 0, function* () {
            //check expiration and get new token if needed
            let token = storage === null || storage === void 0 ? void 0 : storage.GetStorage();
            const currentTime = Date.now();
            if (!token || token.expiresAt <= currentTime) {
                token = yield this.getToken(storage);
            }
            if (!token) {
                return;
            }
            this.AuthToken = token;
            let authTokenExpireCheck = token.expiresAt - currentTime;
            if (authTokenExpireCheck <= 0) {
                authTokenExpireCheck = 0;
            }
            //restart timeout
            setTimeout(() => { void this.checkTokenExpiration(storage); }, authTokenExpireCheck);
        });
    }
    getExpirationDateTime(expireSeconds) {
        return Date.now() + ((expireSeconds - this.AuthSettings.AlmeAuthorizationExpireBufferSeconds) * 1000);
    }
    AddAuthHeader(requestInit) {
        if (this.AuthToken && this.AuthToken.token.TokenType && this.AuthToken.token.Token && requestInit) {
            if (requestInit.headers) {
                const newHeaders = new Headers(requestInit.headers);
                newHeaders.append('Authorization', `${this.AuthToken.token.TokenType} ${this.AuthToken.token.Token}`);
                requestInit.headers = newHeaders;
            }
            else {
                requestInit.headers = { 'Authorization': `${this.AuthToken.token.TokenType} ${this.AuthToken.token.Token}` };
            }
        }
    }
}
exports.AuthTokenHandlerBase = AuthTokenHandlerBase;
//# sourceMappingURL=AuthTokenHandlerBase.js.map


// WEBPACK FOOTER //
// ../../Authorization/AuthTokenHandlerBase.ts